// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cp.wf .infos .item{border:1px solid hsla(0,0%,100%,.5);border-radius:4px;margin:10px 0;padding:10px}.cp.wf .infos .item .row{margin:5px 0}.cp.wf .infos .item .row img{display:inline-block;margin:10px;width:60px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
